















































































































































































































































import { Component, Emit, Model, Prop, Ref, Vue, Watch, PropSync } from 'vue-property-decorator';
import CommentThreadPanel from '@/components/comments/CommentThreadPanel.vue';
import ResourceEditingPanel from '@/components/panel/ResourceEditingPanel.vue';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Decisions from '@/store/modules/Decisions';
import Choices from '@/store/modules/Choices';
import Modelling from '@/store/modules/Modelling';
import Comments, { CommentResource, ResourceType } from "@/store/modules/Comments";
import Viewpoints from "@/store/modules/Viewpoints";
import Users from "@/store/modules/Users";
import { getModule } from 'vuex-module-decorators';
import _ from "lodash";
import { VIEWPOINT_API } from '@/api/ViewpointApi';
import { observable } from 'vue/types/umd';

const workspaceOptionsModule = getModule(WorkspaceOptions);
const decisionsModule = getModule(Decisions);
const viewpointsModule = getModule(Viewpoints);
const commentsModule = getModule(Comments);
const usersModule = getModule(Users);
const choicesModule = getModule(Choices);
const modellingModule = getModule(Modelling);


@Component({
    components: {
        CommentThreadPanel,
        ResourceEditingPanel,
    },
})
export default class MainCommentPanel extends Vue {
    @Prop({ default: false, type: Boolean })
    appEmbed!: boolean;

    @Prop({ default: false, type: Boolean })
    mainApp!: boolean;

    @Prop({ default: false, type: Boolean })
    expand!: boolean;

    @Prop({ default: false, type: Boolean })
    shared!: boolean;

    @Ref()
    drag!: HTMLDivElement;

    @Ref()
    dragRight!: HTMLDivElement;

    private sortOptions = ['Ascending', 'Descending'];
    private isBotCommentLoading = false;
    private isBotError = false;
    private botWarningMsg = "There is not enough data to generate comments."
    private botWarningMsgError = [];

    get editComments() {
        return workspaceOptionsModule.editComments;
    }

    mounted() {
        this.setEvents();
    }

    setEvents() {
        const drag = this.drag;
        drag.addEventListener(
            'mousedown',
            (e) => {
                drag.style.transition = 'initial';
                document.body.style.cursor = 'row-resize';
                document.addEventListener('mousemove', this.resize, false);
                document.onselectstart = ()=> false;
            },
            false
        );
        
        document.addEventListener(
            'mouseup',
            () => {
                // console.log('mouseUp');
                drag.style.transition = '';
                // console.log(drawer.style.width);
                document.body.style.cursor = '';
                document.removeEventListener('mousemove', this.resize, false);
            },
            false
        );

        drag.addEventListener(
            'touchstart',
            (e) => {
                // console.log('touch');
                drag.style.transition = 'initial';
                document.body.style.cursor = 'col-resize';
                document.addEventListener('touchmove', this.resizeMobile, false);
                document.onselectstart = ()=> false;
            },
            false
        );
        document.addEventListener(
            'touchend',
            () => {
                // console.log('touch');
                drag.style.transition = '';
                // console.log(drawer.style.width);
                document.body.style.cursor = '';
                document.removeEventListener('touchmove', this.resizeMobile, false);
            },
            false
        );
        // console.log(drawerBorder);

        const dragRight = this.dragRight;
        dragRight.addEventListener(
            'mousedown',
            (e) => {
                dragRight.style.transition = 'initial';
                document.body.style.cursor = 'col-resize';
                document.addEventListener('mousemove', this.resizeRight, false);
                document.onselectstart = ()=> false;
            },
            false
        );

        document.addEventListener(
            'mouseup',
            () => {
                // console.log('mouseUp');
                dragRight.style.transition = '';
                // console.log(drawer.style.width);
                document.body.style.cursor = '';
                document.removeEventListener('mousemove', this.resizeRight, false);
            },
            false
        );

        dragRight.addEventListener(
            'touchstart',
            (e) => {
                // console.log('touch');
                dragRight.style.transition = 'initial';
                document.body.style.cursor = 'col-resize';
                document.addEventListener('touchmove', this.resizeMobileRight, false);
                document.onselectstart = ()=> false;
            },
            false
        );

        document.addEventListener(
            'touchend',
            () => {
                // console.log('touch');
                dragRight.style.transition = '';
                // console.log(drawer.style.width);
                document.body.style.cursor = '';
                document.removeEventListener('touchmove', this.resizeMobileRight, false);
            },
            false
        );
    }
    
    resize(e: any) {
        let f = window.innerHeight - e.clientY;
        // console.log(f);
        if (f < 200) {
            this.commentBottomHeight = 200;
        } else if (f > window.innerHeight) {
            this.commentBottomHeight = window.innerHeight;
        } else {
            this.commentBottomHeight = f;
        }
    }

    resizeMobile(e: any) {
        let f = window.innerHeight - e.changedTouches[0].clientY;
        if (f < 150) {
            this.commentBottomHeight = 150;
        } else if (f > window.innerHeight) {
            this.commentBottomHeight = window.innerHeight;
        } else {
            this.commentBottomHeight = f;
        }
    }

    resizeRight(e: any) {
        let f = window.innerWidth - e.clientX;
        // console.log(f);
        if (f < 200) {
            this.commentRightWidth = 200;
        } else if (f > window.innerWidth) {
            this.commentRightWidth = window.innerWidth;
        } else {
            this.commentRightWidth = f;
        }
    }

    resizeMobileRight(e: any) {
        let f = window.innerWidth - e.changedTouches[0].clientX;
        if (f < 150) {
            this.commentRightWidth = 150;
        } else if (f > window.innerWidth) {
            this.commentRightWidth = window.innerWidth;
        } else {
            this.commentRightWidth = f;
        }
    }
    // filterResources = [];
    // filterTags = [];
    // filterUsers = [];
    // sortOrder = "Descending";
    get menu() {
        return workspaceOptionsModule.commentMenuOpen;
    }

    set menu(open: boolean) {
        workspaceOptionsModule.setCommentMenuOpen(open);
    }

    get pluralChoiceLabel(){
        return decisionsModule.pluralChoiceLabel;
    }
    get singlarViewpointLabel(){
        return decisionsModule.singularViewpointLabel;
    }
    get pluralFactorLabel(){
        return decisionsModule.pluralFactorLabel;
    }
    get filterResources() {
        return workspaceOptionsModule.filterResources;
    }

    set filterResources(val: any) {
        workspaceOptionsModule.setFilterResources(val);
    }

    get filterTags() {
        return workspaceOptionsModule.filterTags;
    }

    set filterTags(val: any) {
        workspaceOptionsModule.setFilterTags(val);
    }

    get filterUsers() {
        return workspaceOptionsModule.filterUsers;
    }

    set filterUsers(val: any) {
        workspaceOptionsModule.setFilterUsers(val);
    }


    get sortOrder() {
        return workspaceOptionsModule.commentSortOrder;
    }

    set sortOrder(val: any) {
        workspaceOptionsModule.setCommentSortOrder(val);
    }

    get resource() {
        if(commentsModule.newSelectedCommentResource){
            return commentsModule.newSelectedCommentResource.resource;
        }else{
            return null;
        }
    }

    get viewpoints() {
        return viewpointsModule.decisionViewpoints || [];
    }

    get commentViews() {
        return workspaceOptionsModule.commentViews;
    }

    set commentView(val: string) {
        workspaceOptionsModule.changeCommentView(val)
    }

    get commentView() {
        return workspaceOptionsModule.commentView;
    }

    get dialog() {
        return workspaceOptionsModule.dialog;
    }

    get openLeft() {
        return workspaceOptionsModule.openLeft;
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    get commentBottomHeight() {
        return workspaceOptionsModule.commentBottomHeight;
    }
    set commentBottomHeight(val: number){
        workspaceOptionsModule.setCommentBottomHeight(val);
    }

    get commentRightWidth() {
        return workspaceOptionsModule.commentRightWidth;
    }

    set commentRightWidth(val: number) {
        workspaceOptionsModule.setCommentRightWidth(val);
    }

    set openRight(open: boolean) {
        if (this.appEmbed) {
            workspaceOptionsModule.setOpenRightEmbed(open);
        } else {
            workspaceOptionsModule.setOpenRight(open);
        }
    }

    set commentVertical(vertical: boolean) {
        workspaceOptionsModule.setCommentVertical(vertical);
    }

    get commentVertical() {
        return workspaceOptionsModule.commentVertical;
    }

    get openRight() {
        // this.generateUrl();
        return workspaceOptionsModule.openRight;
    }

    get pinnedRight() {
        return workspaceOptionsModule.pinnedRight;
    }

    set pinnedRight(pinnedRight: boolean) {
        workspaceOptionsModule.setPinnedRight(pinnedRight);
    }

    get leftPanelWidth() {
        return workspaceOptionsModule.leftPanelWidth;
    }

    get commentPanelWidth() {
        if (this.mainApp) {
            return this.commentVertical
                ? this.openLeft
                    ? `calc(100vw - 90px - ${this.leftPanelWidth})`
                    : 'calc(100vw - 90px)'
                : this.commentRightWidth + 'px';
        }
        if (this.expand) {
            return this.commentVertical ? `calc(100vw)` : this.commentRightWidth + 'px';
        }
        if (this.shared) {
            return this.commentVertical
                ? this.openLeft
                    ? `calc(100vw - ${this.leftPanelWidth})`
                    : 'calc(100vw - 40px)'
                : '360px';
        }
    }
  
    get allResources(): any[] {
        if (!this.viewpoints && this.viewpoints.length === 0) {
            return [{}];
        }
        return this.commentKeys.map(key => {
            if (key === 'Choice') {
                return {name: 'Choice' , id: 'Choice'};
            }
            if (key === 'MODEL') {
                return {name:'Model', id: 'MODEL'};
            }
            return {name: this.viewpointsMap[key]?.name, id: key}});
    }
    
    get allComments() {
        return commentsModule.allComments;
    }
    get viewpointsMap() {
        return viewpointsModule.decisionViewpointsMap;
    }

    get commentUsers() {
        let userList: {displayName:string, userId: string}[] = [];
        for (let comment of Object.values(this.allComments).flat()) {
            if (!_.includes(userList, {displayName: this.getDisplayName(comment.userId), userId: comment.userId})) {
                userList.push({displayName: this.getDisplayName(comment.userId), userId: comment.userId});
            }
        }
        return userList;
    }

    get commentKeys() {
        let keys = Object.keys(this.allComments);
        if (keys.length === 0) {
            return [this.resource.id];
        }
        keys = keys.sort((a,b)=> {
            if (a === this.resource.name) {
                return -1;
            }
             if (b === this.resource.name) {
                return 1;
            }
            if(a < b) {
                return -1;
            }
            if(a > b) {
                return 1;
            }
            if(a === b) {
                return 0;
            }

        })
        return keys;
    }

    get userId(): string {
        if (this.currentUser) {
            return this.currentUser.userId;
        }
        return '';
    }

    get currentUser() {
        return usersModule.currentUserProfile;
    }

    get userProfiles() {
        return usersModule.userProfiles;
    }

    get selectedViewpointIds() {
        return viewpointsModule.selectedViewpointIds;
    }

    get allTags() {
       let tagList = _.cloneDeep(this.selectedDecision.commentAdminTags || [])
       let comment:any;
        for (comment of Object.values(this.allComments).flat()) {
            if (comment.tags && comment.tags.length > 0)
                tagList.push(...comment.tags);
        }
        _.uniq(tagList);
        return tagList;
    }

    get factorRecources() {
        return modellingModule.publishedModelFactorResources;
    }

    get factorKeys() {
        return Object.keys(this.factorRecources);
    }

    get choiceIds() {
        return choicesModule.choiceIds;
    }

    private getDisplayName(userId: string) {
        let user: any;
        if (userId === this.userId) {
            return 'You';
            // user = this.currentUser;
        } else {
            user = this.userProfiles[userId];
        }

        if (!user) {
            return null;
        }

        if (!user.first) {
            return user.email.split('@')[0];
        }

        let name = '';
        if (user.first) {
            name = name + user.first;
        }
        if (user.last) {
            name = name + ' ' + user.last;
        }
        return name;
    }

    private async invokeBotComment() {
        // console.log(this.choiceIds.length);
        this.isBotError=false;
        this.botWarningMsgError=[]
        try {
            if( this.selectedDecision.decisionId 
                && this.selectedViewpointIds 
                && this.selectedViewpointIds.length > 0
                && this.choiceIds && this.choiceIds.length >= 2
                && this.factorKeys && this.factorKeys.length >= 5
            ){
                this.isBotCommentLoading = true;
                let botComment = await VIEWPOINT_API.invokeBotComment({
                    decisionId:  this.selectedDecision.decisionId, 
                    viewpointIds: this.selectedViewpointIds
                });
                setTimeout(async () => {
                    await commentsModule.fetchComments();
                    this.isBotCommentLoading = false;
                }, 30000);
                setTimeout(async () => {
                    await commentsModule.fetchComments();
                }, 60000);
                console.log(botComment);
            }else {
                
                if(!this.selectedViewpointIds || this.selectedViewpointIds.length=== 0){
                    this.botWarningMsgError.push(`At least 1 selected ${this.singlarViewpointLabel}`);
                }
                if(!this.choiceIds || this.choiceIds.length < 2){
                    this.botWarningMsgError.push(`At least 2 ${this.pluralChoiceLabel}`);
                }
                if(!this.factorKeys || this.factorKeys.length < 5){
                    this.botWarningMsgError.push(`At least 5 published ${this.pluralFactorLabel}`);
                }
                this.isBotError = true;

            }
        } catch (error) {
            this.isBotCommentLoading = false;
            // console.log(error);
        }

    }

}
